import {deleteFile} from "./DeleteFile";
import {readTextFile} from "./ReadTextFile";
import {writeTextFile} from "./WriteTextFile";

export {deleteFile, readTextFile, writeTextFile}